<script>
import App from '@/App.vue'
import '@/scss/style-default.scss'

export default {
  name: 'AppDefault',
  render: h => h(App)
}
</script>
